export const formFieldConfig = {
    mobile: {
        max: 11, min: 11,
    },
    name: {
        max: 128,
    },
    email: {
        max: 128,
    },
    company: {
        max: 128,
    },
    password: {
        min: 8,
        max: 32,
    },
};
